import { useEffect } from "react";
import { Link, useRouteError } from "react-router";
import { LogoMark } from "../components/Logo";
import { isChunkLoadError, reloadOnceForNewVersion } from "../lib/lazy";

/**
 * Shown instead of a raw stack trace if a screen crashes. Copy is bilingual
 * because this can render outside the i18n provider's normal flow.
 */
export default function RouteError() {
  const error = useRouteError();
  useEffect(() => {
    // A new version was deployed while this tab was open: move to it silently.
    if (isChunkLoadError(error) && reloadOnceForNewVersion()) return;
    console.error("[CafonaPay] route error", error);
  }, [error]);
  return (
    <div className="auth-page" style={{ textAlign: "center" }}>
      <LogoMark size={64} />
      <h1>Something went wrong on this screen.</h1>
      <p className="muted" style={{ maxWidth: "42ch" }}>
        Your money is safe: balances live on our servers, not in this page. Reload, or go back to your home screen.
        <br />
        Un problème est survenu sur cet écran. Votre argent est en sécurité.
      </p>
      <div className="row" style={{ justifyContent: "center", flexWrap: "wrap" }}>
        <button className="btn btn-primary" onClick={() => location.reload()}>
          Reload · Recharger
        </button>
        <Link className="btn" to="/app">
          Home · Accueil
        </Link>
      </div>
    </div>
  );
}
